import React, { useState, useEffect, useLayoutEffect } from "react";
import {
  Navigation,
  Main,
  About,
  Project,
  Timeline,
  Contact,
  Footer,
} from "./components";
import "./index.scss";

type Theme = "dark" | "light";

function getInitialTheme(): Theme {
  try {
    const saved = localStorage.getItem("sb-theme");
    if (saved === "dark" || saved === "light") return saved;
  } catch (e) {
    /* ignore */
  }
  return "dark";
}

function App() {
  const [theme, setTheme] = useState<Theme>(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try {
      localStorage.setItem("sb-theme", theme);
    } catch (e) {
      /* ignore */
    }
  }, [theme]);

  // Scroll reveal — apply hidden state before paint to avoid flash
  useLayoutEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || !("IntersectionObserver" in window)) return;

    const els = Array.from(
      document.querySelectorAll<HTMLElement>("[data-reveal]")
    );
    els.forEach((el) => el.classList.add("reveal-init"));

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("reveal-in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  const toggleTheme = () =>
    setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <div id="top">
      <Main />
      <About />
      <Project />
      <Timeline />
      <Contact />
      <Footer />
      <Navigation theme={theme} toggleTheme={toggleTheme} />
    </div>
  );
}

export default App;
